import Subscription from './Subscription.json';

export default {
  Subscription,
};
